import { connect } from 'react-redux';
import { toggleApproveModal } from 'project/ducks/wrapup';
import { fetchMessagesIfNeeded } from 'common/ducks/message';
import { getProject } from 'project/ducks/project';
import FinalName from 'project/components/wrapup/final_name';
import { getProjectUrl } from 'project/utils';
import { getSubCategory } from 'common/ducks/categories';
import { getPrepopulatedWrapupMsgOpts } from 'admin/utils';

const mapStateToProps = (state, { wrapup }) => {
  const project = state.admin.projects.currentProject || getProject(state);
  const subCategory = getSubCategory(state.categories, project.sub_category);
  const projectUrl = getProjectUrl(project, subCategory.slug);
  const user = state.user.profile_data;

  return {
    showingApproveModal: state.project.wrapup.showingApproveModal,
    approveChecklist: subCategory.client_approve_name_checklist,
    prepopulatedMsgOpts: getPrepopulatedWrapupMsgOpts({ user, project, wrapup, step: "final_name" }),
    user,
    project,
    projectUrl
  };
};

export default connect(mapStateToProps, {
  toggleApproveModal,
  fetchMessagesIfNeeded
})(FinalName);



// WEBPACK FOOTER //
// ./project/containers/wrapup/final_name.js